import Image from 'next/image';
import { FC } from 'react';

interface Props {
  disableCancel?: boolean;
  onClickOption?: () => void;
  onCancel?: () => void;
  onFinish?: () => void;
}

export const Menu: FC<Props> = ({ disableCancel, onClickOption, onCancel, onFinish }) => (
  <div className="absolute bottom-[5rem] z-[9999] mb-0 flex w-[13.5rem] cursor-pointer flex-col  items-start justify-evenly overflow-hidden rounded-[.125rem] bg-[#7E8A9A] px-[.5rem] font-bold opacity-90">
    {!!onClickOption && (
      <button
        className="w-full cursor-pointer border-none bg-transparent py-2 font-bold text-white hover:opacity-70"
        onClick={onClickOption}
      >
        <span className="flex items-center">
          <Image src="/option.svg" width={18} height={18} alt="" />
          <span className="pl-[.5rem]">追加オプション</span>
        </span>
      </button>
    )}
    {!!onFinish && (
      <button
        className="w-full cursor-pointer border-none bg-transparent py-2 font-bold text-white hover:opacity-70"
        onClick={onFinish}
      >
        <span className="flex items-center">
          <Image src={'/check.svg'} width={18} height={18} alt="" />
          <span className="pl-[.5rem]">鑑定終了</span>
        </span>
      </button>
    )}
    {!!onCancel && (
      <button
        className="w-full cursor-pointer border-none bg-transparent py-2 font-bold text-white hover:opacity-70"
        onClick={onCancel}
        disabled={disableCancel}
      >
        <span className="flex items-center">
          <Image src={'/cross.svg'} width={18} height={18} alt="" />
          <span className="pl-[.5rem]">
            {disableCancel ? 'キャンセル申請中' : '鑑定キャンセル'}
          </span>
        </span>
      </button>
    )}
  </div>
);
